// Anahtar (lightSwitch) gizleme durumu — sahne görünümü + export skip.
// Kullanıcı isteği: bazı aydınlatma hatlarında anahtar olmayabiliyor; seçili
// anahtar gizlenince editörde soluk (şeffaf) görünür ama PDF/DXF'e HİÇ export edilmez.

const HIDDEN_OPACITY = 0.25;

/**
 * Bir anahtar mesh grubunu gizli/görünür yapar.
 * Gizli  → tüm alt materyaller yarı-saydam (opacity 0.25) + üst grup userData.exportHidden=true
 * Görünür → opaklık eski değerine döner, bayrak temizlenir.
 * @param {THREE.Object3D} mesh - anahtarın üst grubu
 * @param {boolean} hidden
 */
export function applySwitchHidden(mesh, hidden) {
  if (!mesh) return;
  mesh.userData = mesh.userData || {};
  mesh.userData.exportHidden = !!hidden;
  mesh.traverse((child) => {
    const mats = Array.isArray(child.material)
      ? child.material
      : (child.material ? [child.material] : []);
    mats.forEach((m) => {
      if (!m) return;
      if (hidden) {
        // İlk gizlemede orijinal opaklığı sakla (geri döndürmek için)
        if (m.userData?.__prevOpacity === undefined) {
          m.userData = m.userData || {};
          m.userData.__prevOpacity = m.opacity;
        }
        m.transparent = true;
        m.opacity = HIDDEN_OPACITY;
      } else {
        const prev = m.userData?.__prevOpacity;
        m.opacity = (prev === undefined ? 1 : prev);
        m.transparent = m.opacity < 1;
        if (m.userData) delete m.userData.__prevOpacity;
      }
      m.needsUpdate = true;
    });
  });
}

/**
 * obj veya herhangi bir atası export'tan gizli mi? (DXFWriter/PdfExporter skip için)
 * Anahtar grubuna bayrak konur; alt çizgi mesh'leri traverse'de ayrı ziyaret
 * edildiği için ata zinciri kontrol edilir.
 * @param {THREE.Object3D} obj
 * @returns {boolean}
 */
export function isExportHidden(obj) {
  let a = obj;
  while (a) {
    if (a.userData && a.userData.exportHidden) return true;
    a = a.parent;
  }
  return false;
}
